<template>
  <ModalImposicion
    v-if="buscarImposicionVisible"
    :visible="buscarImposicionVisible"
    :parametros-cotizacion="parametrosParaBackend"
    :material-heredado="datosImpresion.materialHeredado"
    :maquinas-disponibles="maquinasDisponibles"
    :label-medida-eje="labelMedidaEje"
    :label-medida-desarrollo="labelMedidaDesarrollo"
    :label-gap-eje="labelGapAlEje"
    :label-gap-desarrollo="labelGapAlDesarrollo"
    :label-etiquetas-eje="labelEtiquetasAncho"
    :label-etiquetas-desarrollo="labelEtiquetasDesarrollo"
    :label-laterales="labelLaterales"
    @cerrar="buscarImposicionVisible = false"
    @aplicar="handleAplicarImposicion"
  />
  <input-suaje-engranaje
    v-if="buscarEngranjeVisible"
    :visible="buscarEngranjeVisible"
    :medidaEje="modelValue.MedidaEje"
    :medidaDesarrollo="modelValue.MedidaDesarrollo"
    :unidadMedida="modelValue.UnidadMedida"
    :cantidadColores="cantidadColores"
    @cerrar-buscar-engranaje="handleCerrarBuscarEngranaje"
    @seleccionar-engranaje="seleccionarEngranaje"
  />
  <input-suaje-drawer
    :visible="buscarSuajeVisible"
    :adaptadores="mostrarGestionAdaptadores"
    :medidaEjeMm="modelValue.MedidaEje"
    :medidaDesarrolloMm="modelValue.MedidaDesarrollo"
    :medidaEjeIn="modelValue.MedidaEje / FACTOR"
    :medidaDesarrolloIn="modelValue.MedidaDesarrollo / FACTOR"
    :unidadMedida="modelValue.UnidadMedida"
    @cerrar-buscar-suaje="handleCerrarBuscarSuaje"
    @seleccionar-suaje="seleccionarSuaje"
  />
  <el-row :gutter="24">
    <el-col
      v-if="mostrarBotonBuscarSuaje"
      :span="5"
      data-testid="btnBuscarSuaje"
    >
      <div class="custom-label">{{ labelTituloSeccion }}</div>
      <el-button-group>
        <el-button
          type="primary"
          size="default"
          @click="handleAbrirBuscarSuaje"
          >{{ labelBuscarSuaje }}</el-button
        >
        <el-button
          type="primary"
          size="default"
          disabled
          >{{
            modelValue && modelValue.Suaje && modelValue.Suaje.CodigoSuaje
              ? modelValue.Suaje.CodigoSuaje
              : '-'
          }}</el-button
        >
        <el-button
          type="danger"
          size="default"
          :icon="IconDelete"
          @click="deseleccionarSuaje"
        />
      </el-button-group>
    </el-col>
    <el-col
      v-if="mostrarUnidadMedida"
      :span="3"
    >
      <div class="custom-label">{{ labelUnidadMedida }}</div>
      <el-radio-group
        v-model="unidad"
        size="default"
      >
        <el-radio-button
          label="mm"
          value="mm"
        />
        <el-radio-button
          label="in"
          value="in"
        />
      </el-radio-group>
    </el-col>
    <el-col
      v-if="mostrarBotonEngranaje"
      :span="4"
      class="button-container"
    >
      <el-button-group style="display: flex">
        <el-button
          type="primary"
          size="default"
          @click="handleAbrirBuscarEngranaje"
        >
          {{ labelBotonEngranaje }}
        </el-button>
        <el-button
          v-if="
            deshabilitarSeleccionImposicion || (modelValue.Engranaje && modelValue.Engranaje > 0)
          "
          type="danger"
          size="default"
          :icon="IconDelete"
          title="Quitar imposición seleccionada"
          @click="deseleccionarImposicion"
        />
      </el-button-group>
    </el-col>
    <CustomData
      v-if="mostrarEngranaje"
      :label="'Engranaje'"
      :data="modelValue.Engranaje"
      :span="1"
    />
    <CustomData
      v-if="mostrarDesarrollo"
      :label="'Desarrollo'"
      :data="modelValue.Desarrollo"
      :span="1"
    />
    <CustomData
      v-if="mostrarCilindro"
      :label="'Cilindro'"
      :data="cilindroNombreDisplay"
      :span="1"
    />
    <CustomData
      v-if="mostrarCantidadCilindro"
      :label="labelCantidadCilindros"
      :data="cilindrosCantDisplay"
      :span="2"
    />
    <CustomData
      v-if="mostrarCantidadMagneticos"
      :label="labelCantidadMagneticos"
      :data="magneticosCantDisplay"
      :span="3"
    />
  </el-row>
  <el-row
    type="flex"
    justify="space-between"
    align="middle"
    :gutter="20"
  >
    <el-col
      :xs="24"
      :lg="mostrarVistaImposicion ? 16 : 24"
    >
      <el-row :gutter="24">
        <custom-input-number
          v-if="mostrarMedidaEje"
          v-model="displayMedidaEje"
          :label="labelMedidaEje + ' ' + labelUnidad"
          :spanColumn="4"
          :settings="{
            placeholder: 'Medida al eje',
            inputClass: {
              'input-error': !validate.MedidaEje || false,
            },
            disabled: deshabilitarCamposSuaje,
            min: 0,
            precision: 4,
            step: 0.01,
            controls: false,
          }"
        />
        <custom-input-number
          v-if="mostrarMedidaDesarrollo"
          v-model="displayMedidaDesarrollo"
          :label="labelMedidaDesarrollo + ' ' + labelUnidad"
          :spanColumn="4"
          :settings="{
            placeholder: 'Medida al Desarrollo',
            inputClass: {
              'input-error': !validate.MedidaDesarrollo || false,
            },
            disabled: deshabilitarCamposSuaje,
            min: 0,
            precision: 4,
            step: 0.01,
            controls: false,
          }"
        />
        <custom-input-number
          v-if="mostrarGapEje"
          v-model="displayGapEje"
          :label="labelGapAlEje + ' ' + labelUnidad"
          :spanColumn="5"
          :settings="{
            placeholder: 'Gap al Eje',
            inputClass: {
              'input-error': !validate.GapEje || false,
            },
            min: 0,
            precision: 4,
            step: 0.01,
            controls: false,
          }"
        />
        <custom-input-number
          v-if="mostrarGapDesarrollo"
          v-model="displayGapDesarrollo"
          :label="labelGapAlDesarrollo + ' ' + labelUnidad"
          :spanColumn="5"
          :settings="{
            placeholder: 'Gap al Desarrollo',
            inputClass: {
              'input-error': !validate.GapDesarrollo || false,
            },
            disabled: deshabilitarCamposSuaje,
            min: 0,
            precision: 4,
            step: 0.01,
            controls: false,
          }"
        />
        <custom-input-number
          v-if="mostrarBase"
          v-model="displayBase"
          :label="labelBase + ' ' + labelUnidad"
          :spanColumn="3"
          :settings="{
            placeholder: 'Base',
            inputClass: {
              'input-error': !validate.Base || false,
            },
            min: 0,
            precision: 2,
            step: 0.01,
            controls: false,
          }"
        />
        <custom-input-number
          v-if="mostrarSolapa"
          v-model="displaySolapa"
          :label="labelSolapa + ' ' + labelUnidad"
          :spanColumn="3"
          :settings="{
            placeholder: 'Solapa',
            inputClass: {
              'input-error': !validate.Solapa || false,
            },
            min: 0,
            precision: 2,
            step: 0.01,
            controls: false,
          }"
        />
        <custom-input-number
          v-if="mostrarSellado"
          v-model="displaySellado"
          :label="labelSellado + ' ' + labelUnidad"
          :spanColumn="3"
          :settings="{
            placeholder: 'Sellado',
            inputClass: {
              'input-error': !validate.Sellado || false,
            },
            min: 0,
            precision: 2,
            step: 0.01,
            controls: false,
          }"
        />
        <custom-input-number
          v-if="mostrarAnchoTotal"
          v-model="numericAnchoTotal"
          :label="labelAnchoTotal + ' ' + labelUnidad"
          :spanColumn="3"
          :settings="{
            placeholder: 'Ancho Total',
            min: 0,
            precision: 2,
            step: 0.01,
            controls: false,
            disabled: true,
          }"
        />
        <custom-input-number
          v-if="mostrarAltoTotal"
          v-model="numericAltoTotal"
          :label="labelAltoTotal + ' ' + labelUnidad"
          :spanColumn="3"
          :settings="{
            placeholder: 'Alto Total',
            min: 0,
            precision: 2,
            step: 0.01,
            controls: false,
            disabled: true,
          }"
        />
      </el-row>
      <el-row :gutter="24">
        <custom-input-number
          v-if="mostrarEtiquetasAncho"
          :label="labelEtiquetasAncho"
          :spanColumn="5"
          :settings="{
            placeholder: 'Etiquetas en Ancho',
            inputClass: {
              'input-error': !validate.EtiquetasEje || false,
            },
            disabled: modelValue.Suaje && modelValue.Suaje.Codigo > 0,
            min: 0,
            precision: 4,
            step: 0.01,
            controls: false,
          }"
          :model-value="modelValue.EtiquetasEje"
          @input="handlePropiedadElemento(+$event.target.value, 'EtiquetasEje')"
        />
        <custom-input-number
          v-if="mostrarEtiquetasDesarrollo"
          :label="labelEtiquetasDesarrollo"
          :spanColumn="5"
          :settings="{
            placeholder: 'Etiquetas desarrollo',
            inputClass: {
              'input-error': !validate.EtiquetasDesarrollo || false,
            },
            disabled: deshabilitarCamposSuaje,
            min: 0,
            precision: 4,
            step: 0.01,
            controls: false,
          }"
          :model-value="modelValue.EtiquetasDesarrollo"
          @input="handlePropiedadElemento(+$event.target.value, 'EtiquetasDesarrollo')"
        />
        <!--
          COTI-633: exclusivo de Offset. Caso real que lo motivó: un pliego con muchos
          ítems (20, 30 o más) de formas y medidas distintas entre sí — el sistema
          todavía no soporta cargar esa variedad en un elemento, así que el usuario
          agrupa todo en un único Ancho item / Largo item y necesita poder cargar la
          cantidad real de bocas sin que el mínimo del pliego la use (daría un mínimo
          absurdamente grande, calculado para ítems todos iguales).

          El valor cargado en bocas ancho/largo siempre se guarda igual; esto solo
          decide si el mínimo de pliego lo usa (repeticiones reales, true) o usa 1
          (false) — ver calcularMinimosPliego en use_minimos_pliego.js. Por defecto
          true: sin dato (elemento nuevo, todavía sin guardar) se muestra activo, igual
          que lo que va a persistir el backend.
        -->
        <custom-switch
          v-if="mostrarAnchoLargoItem"
          :model-value="modelValue.ValidarCantidadBocas ?? true"
          label="Validar bocas"
          :spanColumn="5"
          :settings="{
            disabled: false,
            activeText: 'Sí',
            inactiveText: 'No',
            tooltip:
              'Desactivalo cuando en el mismo pliego vas a producir varios ítems de medidas distintas. Así podés cargar la cantidad real de bocas sin que el mínimo del pliego se calcule con esas medidas.',
          }"
          @update:model-value="(val) => handlePropiedadElemento(val, 'ValidarCantidadBocas')"
        />
        <custom-select
          v-if="mostrarForma"
          v-model="forma"
          :label="labelForma"
          :spanColumn="5"
          :settings="{
            inputClass: { 'input-error': !validate.Forma || false },
            placeholder: 'Seleccionar forma',
            disabled: deshabilitarCamposSuaje,
            options: formaList,
          }"
        />
      </el-row>

      <el-row :gutter="24">
        <custom-input-number
          v-if="mostrarLaterales"
          v-model="displayLaterales"
          :label="labelLaterales + ' ' + labelUnidad"
          :spanColumn="5"
          :settings="{
            placeholder: 'Laterales',
            min: 0,
            precision: 4,
            step: 0.01,
            controls: false,
          }"
          @input="handlePropiedadElemento(+$event.target.value, 'Laterales')"
        />
        <custom-input-number
          v-if="mostrarMargenSuperior"
          v-model="displayMargenSuperior"
          :label="labelMargenSuperior"
          :spanColumn="5"
          :settings="{
            placeholder: labelMargenSuperior,
            min: 0,
            precision: 4,
            step: 0.01,
            controls: false,
            inputClass: { 'input-error': !validate.MargenSuperior || false },
          }"
          @input="handlePropiedadElemento(+$event.target.value, 'MargenSuperior')"
        />

        <custom-input-number
          v-if="mostrarAnchoMinimo"
          :label="labelAnchoMinimo + ' ' + labelUnidad"
          :spanColumn="5"
          :settings="{
            placeholder: labelAnchoMinimo,
            min: 0,
            precision: precisionAnchoMinimo,
            step: 0.01,
            controls: false,
            disabled: aplicaRegla,
            inputClass: { 'input-error': showAnchoWarning },
          }"
          :model-value="anchoMinimoDisplay"
        />
        <el-col
          v-if="showAnchoWarning"
          :span="5"
          style="align-self: flex-end; margin-top: -6px"
        >
          <div class="helper-danger">
            El ancho mínimo ({{ formatNumberLocale(anchoMinimoDisplay, 4) }}) es superior al ancho
            del item ({{ formatNumberLocale(anchoMaterialDisplay, 4) }}).
          </div>
        </el-col>
        <custom-input-number
          v-if="mostrarAnchoMaterial"
          v-model="displayAnchoMaterial"
          :label="labelAnchoMaterial + ' ' + labelUnidad"
          :spanColumn="5"
          :settings="{
            placeholder: 'Ancho item',
            inputClass: { 'input-error': !validate.AnchoMaterial || false },
            min: 0,
            precision: 4,
            step: 0.00001,
            controls: false,
            disabled: aplicaRegla,
          }"
          @input="handlePropiedadElemento(+$event.target.value, 'AnchoMaterial')"
        />
      </el-row>
      <el-row :gutter="24">
        <!--
          COTI-502: dimensiones del pliego
        -->
        <medida-pliego
          v-if="mostrarAnchoLargoItem"
          v-model="displayAnchoItem"
          :label="'Ancho pliego ' + labelUnidad"
          :labelMinimo="'Ancho mín. pliego ' + labelUnidad"
          :minimo="minimoEnUnidad(modelValue.AnchoMinimoHojaCalculado)"
          :decimales="decimalesUnidad"
          mensajeMinimo="El ancho del pliego no llega al mínimo"
          :spanColumn="4"
        />
        <medida-pliego
          v-if="mostrarAnchoLargoItem"
          v-model="displayLargoItem"
          :label="'Largo pliego ' + labelUnidad"
          :labelMinimo="'Largo mín. pliego ' + labelUnidad"
          :minimo="minimoEnUnidad(modelValue.LargoMinimoHojaCalculado)"
          :decimales="decimalesUnidad"
          mensajeMinimo="El largo del pliego no llega al mínimo"
          :spanColumn="4"
        />
        <!--
          COTI-633: margenes de pinza y cola del pliego (sentido de alimentación). El largo
          mínimo del pliego los usa: MedidaDesarrollo + Pinza + Cola.
        -->
        <custom-input-number
          v-if="mostrarAnchoLargoItem"
          v-model="displayPinza"
          :label="'Pinza ' + labelUnidad"
          :spanColumn="3"
          :settings="{
            placeholder: 'Pinza',
            min: 0,
            precision: 4,
            step: 0.01,
            controls: false,
          }"
        />
        <custom-input-number
          v-if="mostrarAnchoLargoItem"
          v-model="displayCola"
          :label="'Cola ' + labelUnidad"
          :spanColumn="3"
          :settings="{
            placeholder: 'Cola',
            min: 0,
            precision: 4,
            step: 0.01,
            controls: false,
          }"
        />
        <el-col
          v-if="mostrarAnchoLargoItem && errorMaximoMaquinaPliego"
          :span="24"
          style="margin-top: -6px"
        >
          <div class="helper-danger">
            {{ errorMaximoMaquinaPliego }}
          </div>
        </el-col>
        <!--
          COTI-502: cuántos pliegos salen de cada hoja del proveedor. Es un contador, no una
          medida, así que no lleva conversión mm/in. El motor lo usa cuando el material se
          compra en Hoja: hojas = ceil(pliegos / PliegosPorHoja). En 0 el material queda en
          cero, por decisión de producto (ver costeo-material.ts).
        -->
        <custom-input-number
          v-if="mostrarPliegosPorHoja"
          :label="'Pliegos por hoja'"
          :spanColumn="3"
          :settings="{
            placeholder: 'Pliegos por hoja',
            min: 0,
            precision: 0,
            step: 1,
            controls: false,
          }"
          :model-value="modelValue.PliegosPorHoja"
          @input="handlePropiedadElemento(+$event.target.value, 'PliegosPorHoja')"
        />
        <custom-input-number
          v-if="mostrarPaginas"
          :label="labelPaginas"
          :spanColumn="3"
          :settings="{
            placeholder: 'Páginas',
            min: 0,
            precision: 0,
            step: 1,
            controls: false,
          }"
          :model-value="modelValue.Paginas"
          @input="handlePropiedadElemento(+$event.target.value, 'Paginas')"
        />
      </el-row>
    </el-col>
    <el-col
      v-if="mostrarVistaImposicion"
      :xs="24"
      :lg="8"
    >
      <div class="display: flex">
        <div
          class="custom-label"
          style="margin-bottom: 8px; margin-right: 16px"
        >
          {{ labelVistaImposicion }}
        </div>
        <el-button-group v-if="mostrarBotonesRotacion">
          <el-button
            size="small"
            :icon="IconRotateLeftVariant"
            @click="rotarImposicion('left')"
          />
          <el-button
            size="small"
            :icon="IconRotateRightVariant"
            @click="rotarImposicion('right')"
          />
        </el-button-group>
      </div>
      <custom-imposicion
        :cavidadesAncho="cavidadesAncho"
        :cavidadesDesarrollo="cavidadesDesarrollo"
        :gapDesarrollo="gapDesarrollo"
        :gapEje="gapEje"
        :medidaAlEje="medidaEje"
        :medidaAlDesarrollo="medidaDesarrollo"
        :laterales="numericLaterales"
        :showLabels="true"
        :anchoImposicion="rotacionAnchoImposicion"
        :largoImposicion="rotacionLargoImposicion"
        :aspectRatio="aspectRatio"
        :maxDisplayHeight="maxDisplayHeight"
        :maxDisplayWidth="maxDisplayWidth"
        :rotacion="rotacionImposicion"
        :mostrarSentidoAvance="mostrarSentidoAvance"
      />
    </el-col>
  </el-row>
</template>

<script setup>
import {
  computed,
  onBeforeMount,
  ref,
  onMounted,
  inject,
  watch,
} from 'vue';
import { useAplicaRegla } from '@/shared/composables/use_aplica_regla.js';
import { resolverDimensionesItem } from '@/shared/utils/dimensiones_item.js';
import {
  calcularErrorMaximoMaquinaPliego,
  noLlegaAlMinimoPliego,
} from '@/shared/utils/margenes_pliego_maquina.js';
import { useErrorRegistro } from '@/shared/composables/use_error_registry.js';
import { useSwageStore } from '@/stores/swage_store.js';
import { useFormaStore } from '@/stores/forma/forma_store';
import forma_model from '@/shared/models/forma_model';
import suaje_model from '@/shared/models/suaje_model';
import CustomInputNumber from '@/shared/components/custom_input_number.vue';
import CustomSelect from '@/shared/components/custom_select.vue';
import CustomData from '@/shared/components/custom_data.vue';
import CustomSwitch from '@/shared/components/custom_switch.vue';
import MedidaPliego from '@/shared/components/suaje/medida_pliego.vue';
import InputSuajeDrawer from '@/shared/components/suaje/input_suaje_drawer.vue';
import InputSuajeEngranaje from '@/shared/components/suaje/input_suaje_engranaje.vue';
import ModalImposicion from '../modal_imposicion.vue';
import IconDelete from '~icons/mdi/delete';
import { storeToRefs } from 'pinia';
import { ElNotification } from 'element-plus';
import {
  useConverter,
  FACTOR,
} from '@/shared/composables/useUnitConversion';
import {
  calcularEtiquetasDesarrolloImpresion,
  calcularGapDesarrollo,
} from '@/shared/composables/useSuajeAdaptador.js';
import CustomImposicion from '@/shared/components/custom_imposicion.vue';
import { Modules } from '@/enum/modules';
import { ElementoBase } from '@/enum/elemento_base';
import { useDesarrolloStore } from '@/stores/desarrollo/desarrollo_store.js';
import { useConfiguracionStore } from '@/stores/configuracion-general.js';
import { useConfiguracionesPorDefectoStore } from '@/views/configuraciones_por_defecto/stores/configuraciones_por_defecto_store.js';
import { usePricesStore } from '@/views/prices/stores/prices_store';
import IconRotateLeftVariant from '~icons/mdi/rotate-left-variant';
import IconRotateRightVariant from '~icons/mdi/rotate-right-variant';
import proceso_service from '@/services/proceso_service';
import { formatNumberLocale } from '@/shared/utils/locale_number_utils.js';
import { resolverAnchoItemDesdeExtrusionPrecedente } from '@/shared/utils/procesos_precedentes';
import MaterialService from '@/services/material_service';
import { MaterialGenericoFiltro } from '@/enum/material_generico_filtro.js';

const configuracionStore = useConfiguracionStore();
const configuracionesPorDefectoStore = useConfiguracionesPorDefectoStore();
const desarrollosStore = useDesarrolloStore();
const {
  mostrarBotonesRotacion,
  nuevoMotorImposicion,
  rotacionImposicion: rotacionImposicionDefault,
  mostrarGestionAdaptadores,
} = storeToRefs(configuracionStore);
const {
  tolGapDesarrolloMin: gapToleranciaMinima,
  tolGapDesarrolloMax: gapToleranciaMaxima,
  lateralesImposicion,
  gapEjeImposicion,
  gapDesarrolloImposicion,
} = storeToRefs(configuracionesPorDefectoStore);
const { desarrollos } = storeToRefs(desarrollosStore);
const pricesStore = usePricesStore();
const { cotizacion } = storeToRefs(pricesStore);

const currentModule = inject('currentModule');

// Extrusion
const cantidadProcesos = computed(() => (props.modelValue.ElementoProcesos || []).length);
const cantidadProcesosExtrusion = computed(
  () =>
    (props.modelValue.ElementoProcesos || []).filter((proceso) => {
      return proceso.Proceso?.Codigo === 1; // Assuming 1 is the code for extrusion
    }).length,
);

// Definición única en use_aplica_regla.js. Acá aplica en los cuatro módulos.
const aplicaRegla = useAplicaRegla();

const mostrarSentidoAvance = computed(() => {
  const codigoBase = props.modelValue?.ElementoTipo?.CodigoElementoBase;
  return codigoBase === ElementoBase.ETIQUETA || codigoBase === ElementoBase.FLEXIBLE;
});

const swageStore = useSwageStore();
const formaStore = useFormaStore();
const { swageUsed } = storeToRefs(swageStore);
const { formaList } = storeToRefs(formaStore);
const { firstForma } = formaStore;

const cantidadCilindros = ref('');
const cantidadMagneticos = ref('');
const cilindros = ref('');
const buscarSuajeVisible = ref(false);
const deshabilitarSeleccionImposicion = ref(false);

const anchoMinimoMM = inject(
  'anchoMinimoMM',
  computed(() => 0),
);
const selectedMaterialAnchoMM = inject('selectedMaterialAnchoMM', ref(0));

const ROTACION_0 = 0,
  ROTACION_90 = 90,
  ROTACION_180 = 180,
  ROTACION_270 = 270;
const MAX_DISPLAY_WIDTH = 450,
  MAX_DISPLAY_HEIGHT = 300;
const rotaciones = [ROTACION_0, ROTACION_90, ROTACION_180, ROTACION_270];

const props = defineProps({
  modelValue: {
    type: Object,
    required: true,
  },
  validate: {
    type: Object,
    required: true,
  },
  mostrarBotonBuscarSuaje: { type: Boolean, default: true },
  mostrarUnidadMedida: { type: Boolean, default: true },
  mostrarBotonEngranaje: { type: Boolean, default: true },
  mostrarEngranaje: { type: Boolean, default: true },
  mostrarDesarrollo: { type: Boolean, default: true },
  mostrarCilindro: { type: Boolean, default: true },
  mostrarCantidadCilindro: { type: Boolean, default: true },
  mostrarCantidadMagneticos: { type: Boolean, default: true },
  mostrarMedidaEje: { type: Boolean, default: true },
  mostrarMedidaDesarrollo: { type: Boolean, default: true },
  mostrarGapEje: { type: Boolean, default: true },
  mostrarGapDesarrollo: { type: Boolean, default: true },
  mostrarEtiquetasAncho: { type: Boolean, default: true },
  mostrarEtiquetasDesarrollo: { type: Boolean, default: true },
  mostrarForma: { type: Boolean, default: true },
  mostrarLaterales: { type: Boolean, default: true },
  mostrarMargenSuperior: { type: Boolean, default: false },
  mostrarAnchoMinimo: { type: Boolean, default: true },
  mostrarAnchoMaterial: { type: Boolean, default: true },
  /** COTI-502: Ancho/Largo item editables. Sólo offset los usa por ahora. */
  mostrarAnchoLargoItem: { type: Boolean, default: false },
  /** COTI-502: relación pliegos por hoja, para materiales que se compran en Hoja. */
  mostrarPliegosPorHoja: { type: Boolean, default: false },
  mostrarPaginas: { type: Boolean, default: false },
  mostrarVistaImposicion: { type: Boolean, default: true },
  mostrarSolapa: { type: Boolean, default: false },
  mostrarSellado: { type: Boolean, default: false },
  mostrarBase: { type: Boolean, default: false },
  mostrarAltoTotal: { type: Boolean, default: false },
  mostrarAnchoTotal: { type: Boolean, default: false },
  mostrarDescripcionFormula: { type: Boolean, default: false },
  mostrarCantidadColoresFrente: { type: Boolean, default: false },
  mostrarCantidadColoresLiner: { type: Boolean, default: false },
  mostrarCantidadColoresAdhesivo: { type: Boolean, default: false },
  mostrarCantidadCambios: { type: Boolean, default: false },

  labelTituloSeccion: { type: String, default: 'Suaje' },
  labelBuscarSuaje: { type: String, default: 'Buscar suaje' },
  labelUnidadMedida: { type: String, default: 'Unidad medida' },
  labelBotonEngranaje: { type: String, default: 'Nueva Imposicion' },
  labelCantidadCilindros: { type: String, default: 'Cantidad de cilindros' },
  labelCantidadMagneticos: { type: String, default: 'Cantidad de magnéticos' },
  labelMedidaEje: { type: String, default: 'Medida al eje' },
  labelMedidaDesarrollo: { type: String, default: 'Medida al desarrollo' },
  labelGapAlEje: { type: String, default: 'Gap al Eje' },
  labelGapAlDesarrollo: { type: String, default: 'Gap al Des.' },
  labelEtiquetasAncho: { type: String, default: 'Cavidades en Ancho' },
  labelEtiquetasDesarrollo: { type: String, default: 'Cavidades en Desarrollo' },
  labelLaterales: { type: String, default: 'Laterales' },
  labelForma: { type: String, default: 'Forma suaje' },
  labelMargenSuperior: { type: String, default: 'Margen superior' },
  labelAnchoMinimo: { type: String, default: 'Ancho mínimo' },
  labelAnchoMaterial: { type: String, default: 'Ancho item' },
  labelPaginas: { type: String, default: 'Páginas' },
  labelVistaImposicion: { type: String, default: 'Vista de imposición' },
  anchoImposicion: { type: Number, default: 0 },
  largoImposicion: { type: Number, default: 0 },
  labelSolapa: { type: String, default: 'Solapa' },
  labelSellado: { type: String, default: 'Sellado' },
  labelBase: { type: String, default: 'Base' },
  labelAltoTotal: { type: String, default: 'Alto Total' },
  labelAnchoTotal: { type: String, default: 'Ancho Total' },
  labelCantidadColoresFrente: { type: String, default: 'Cantidad colores frente' },
  labelCantidadColoresLiner: { type: String, default: 'Cantidad colores liner' },
  labelCantidadColoresAdhesivo: { type: String, default: 'Cantidad colores adhesivo' },
  labelCantidadCambios: { type: String, default: 'Cantidad cambios' },
  labelDescripcionFormula: { type: String, default: 'Descripcion formula' },
});

const emits = defineEmits(['update:modelValue', 'update:unidadImposicion']);

const unidad = ref(props.modelValue.UnidadMedida || 'mm');
const labelUnidad = computed(() => (unidad.value === 'in' ? '(in)' : '(mm)'));

const toMillimeters = (val) => {
  if (val == null || isNaN(val)) return 0;
  return unidad.value === 'in' ? Number(val) * FACTOR : Number(val);
};

const { converted } = useConverter(() => props.modelValue, unidad, emits);
const displayMedidaEje = converted('MedidaEje');
const displayMedidaDesarrollo = converted('MedidaDesarrollo');
const displayGapEje = converted('GapEje');
const displayGapDesarrollo = converted('GapDesarrollo');
const displayLaterales = converted('Laterales');
const displayAnchoMaterial = converted('AnchoMaterial');
const displayAnchoItem = converted('AnchoItem');
const displayLargoItem = converted('LargoItem');
const displayPinza = converted('Pinza');
const displayCola = converted('Cola');

/** Mínimos de hoja para mostrar: llegan en mm y se pasan a la unidad activa. */
/** Los mínimos se guardan en milímetros; la pantalla puede estar en pulgadas. */
/**
 * El mínimo se lee siempre de los *MinimoHojaCalculado (recalculados con las medidas actuales),
 * nunca de AnchoMinimoMaterial / LargoMinimoMaterial: esos son la copia persistida y pueden
 * estar desactualizados hasta que el cálculo los pise.
 */
const minimoEnUnidad = (mm) => {
  const valor = Number(mm ?? 0);
  return unidad.value === 'in' ? valor / FACTOR : valor;
};

const decimalesUnidad = computed(() => (unidad.value === 'in' ? 4 : 2));

/**
 * COTI-502: Ancho/Largo item siguen al material mientras el usuario no los edite.
 *
 * La decisión de cuándo pisar el valor vive en `resolverDimensionesItem`, que es una función
 * pura y está cubierta por tests: acá sólo se la alimenta con el estado actual y se emite el
 * resultado. `anchoImposicion` y `largoImposicion` son las dimensiones del material que valida
 * ancho, las mismas que Cajas muestra de sólo lectura.
 *
 * Los propios campos entran en las dependencias para detectar tanto el borrado como la edición
 * manual. No hay bucle: cuando no corresponde tocar nada, `hayCambio` es false y no se emite.
 */
const itemAutocompletado = ref({ ancho: null, largo: null });

watch(
  () => [
    props.mostrarAnchoLargoItem,
    props.anchoImposicion,
    props.largoImposicion,
    props.modelValue.AnchoItem,
    props.modelValue.LargoItem,
  ],
  ([mostrar, anchoMaterial, largoMaterial, anchoItem, largoItem]) => {
    if (!mostrar) return;

    const resultado = resolverDimensionesItem({
      anchoItem,
      largoItem,
      anchoMaterial,
      largoMaterial,
      autocompletado: itemAutocompletado.value,
    });

    if (!resultado.hayCambio) return;

    itemAutocompletado.value = resultado.autocompletado;
    emits('update:modelValue', {
      ...props.modelValue,
      AnchoItem: resultado.anchoItem,
      LargoItem: resultado.largoItem,
    });
  },
  { immediate: true },
);
const displaySolapa = converted('Solapa');
const displaySellado = converted('Sellado');
const displayBase = converted('Base');
const displayMargenSuperior = converted('MargenSuperior');

const tolMin = ref(0);
const tolMax = ref(0);

const buscarImposicionVisible = ref(false);
const buscarEngranjeVisible = ref(false);
const maquinasDisponibles = ref([]);
const contextoDocumento = computed(() => {
  let codigoCliente = null;
  let cantidades = [1000];

  switch (currentModule) {
    case Modules.COTIZACION:
      codigoCliente = cotizacion.value.CodigoCliente || cotizacion.value.Cliente?.Codigo || null;
      if (cotizacion.value.CotizacionCantidad && cotizacion.value.CotizacionCantidad.length > 0) {
        cantidades = cotizacion.value.CotizacionCantidad.map((c) => c.Cantidad).filter(Boolean);
      }
      break;
  }

  return {
    codigoCliente,
    cantidadPrincipal: cantidades.length > 0 ? cantidades[0] : 1000,
  };
});

const handleCerrarBuscarEngranaje = () => (buscarEngranjeVisible.value = false);

const seleccionarEngranaje = (engranaje) => {
  if (engranaje) {
    cantidadCilindros.value = engranaje.CantidadCilindros;
    cantidadMagneticos.value = engranaje.CantidadMagneticos;
    cilindros.value = engranaje.Recurso;
    seleccionarSuaje(engranaje);
    deshabilitarSeleccionImposicion.value = true;
  }
};

const obtenerProcesoValidaAncho = (secciones) => {
  if (!secciones) return null;
  for (const seccion of secciones) {
    if (!seccion.ElementoProceso) continue;

    for (const ep of seccion.ElementoProceso) {
      if (ep.CategoriasMaterial) {
        const tieneValidaAncho = ep.CategoriasMaterial.some(
          (catMat) =>
            catMat.ValidaAnchoMaterial === true ||
            catMat.CategoriaMaterial?.ValidaAnchoMaterial === true,
        );
        if (tieneValidaAncho) return ep;
      }
    }
  }
  return null;
};

const datosImpresion = computed(() => {
  const procesoObjetivo = obtenerProcesoValidaAncho(props.modelValue.Secciones);
  if (!procesoObjetivo) return { maquina: null, materialHeredado: {} };

  const maquina = procesoObjetivo.Recurso;
  let materialHeredado = {};

  if (procesoObjetivo.CategoriasMaterial) {
    const categoriaValidaAncho = procesoObjetivo.CategoriasMaterial.find(
      (catMat) =>
        catMat.ValidaAnchoMaterial === true ||
        catMat.CategoriaMaterial?.ValidaAnchoMaterial === true,
    );

    if (
      categoriaValidaAncho &&
      categoriaValidaAncho.ElementoMateriales &&
      categoriaValidaAncho.ElementoMateriales.length > 0
    ) {
      const em = categoriaValidaAncho.ElementoMateriales.find((e) => e.Material);

      if (em) {
        const mat = em.Material;
        materialHeredado = {
          codigoCategoria: mat.MaterialTipo?.CodigoMaterialCategoria || null,
          descCategoria: mat.MaterialTipo?.MaterialCategoria?.Descripcion || null,
          codigoTipo: mat.MaterialTipo?.Codigo || null,
          descTipo: mat.MaterialTipo?.Descripcion || null,
          codigoFamilia: mat.CodigoFamilia || null,
          descFamilia: mat.MateriaPrimaFamilia?.Descripcion || null,
          esGenerico: mat.EsGenerico ?? null,
          descripcionMaterial: em.MaterialDesc || mat.DescripcionInterna || mat.Descripcion || '',
        };
      }
    }
  }

  return { maquina, materialHeredado };
});

const procesoImpresionCodigo = computed(() => {
  const procesoObjetivo = obtenerProcesoValidaAncho(props.modelValue.Secciones);
  return procesoObjetivo?.Proceso?.Codigo || null;
});

watch(
  procesoImpresionCodigo,
  async (codigoProceso) => {
    if (!codigoProceso) {
      maquinasDisponibles.value = [];
      return;
    }
    try {
      const resp = await proceso_service.findRecursosByProceso(codigoProceso);
      maquinasDisponibles.value = resp?.data?.map((r) => r.Recurso).filter(Boolean) || [];
    } catch {
      maquinasDisponibles.value = [];
    }
  },
  { immediate: true },
);

const elementoTipoBackend = computed(() => {
  const base = props.modelValue.ElementoTipo?.CodigoElementoBase;

  switch (base) {
    case 1: // Etiqueta
      return 'ETIQUETA_FLEXO';
    case 3: // Flexible
      return 'FLEXIBLE_FLEXO';
    case 10: // Bolsas BOX
      return 'BOLSA_BOX';
    default:
      return 'DESCONOCIDO';
  }
});

// Con material en la cotización el filtro hereda su condición de genérico; sin material
// queda undefined y el modal aplica el default de Configuración.
const filtroGenericoHeredado = computed(() => {
  const esGenerico = datosImpresion.value.materialHeredado.esGenerico;
  if (esGenerico === true) return MaterialGenericoFiltro.GENERICOS;
  if (esGenerico === false) return MaterialGenericoFiltro.NO_GENERICOS;
  return undefined;
});

const parametrosParaBackend = computed(() => {
  return {
    elementoTipo: elementoTipoBackend.value,
    codigoElementoTipoBase: props.modelValue.ElementoTipo?.Codigo || 0,
    unidadPreferencia: unidad.value || 'mm',
    medidaAncho: Number(displayMedidaEje.value) || 0,
    medidaDesarrollo: Number(displayMedidaDesarrollo.value) || 0,
    gapAncho: Number(displayGapEje.value) || 0,
    gapDesarrollo: Number(displayGapDesarrollo.value) || 0,
    laterales: Number(displayLaterales.value) || 0,
    etiquetasEje: props.modelValue.EtiquetasEje || 0,
    etiquetasDesarrollo: props.modelValue.EtiquetasDesarrollo || 0,
    permitirRotacion: false,
    cantidadSolicitada: contextoDocumento.value.cantidadPrincipal,
    codigoCliente: contextoDocumento.value.codigoCliente,
    criterioRedondeo: 'sin_definir',
    formaTroquel: props.modelValue.Forma?.Codigo || null,
    codigoMaquina: datosImpresion.value.maquina?.Codigo || null,
    codigoMaquinas:
      maquinasDisponibles.value.length > 0
        ? maquinasDisponibles.value.map((m) => m.Codigo)
        : datosImpresion.value.maquina?.Codigo
          ? [datosImpresion.value.maquina.Codigo]
          : [],
    maquina: {
      anchoMaximo: datosImpresion.value.maquina?.AnchoMaximo || 0,
    },
    maquinasDisponibles: maquinasDisponibles.value,
    codigoCategoriaMaterial: datosImpresion.value.materialHeredado.codigoCategoria,
    codigoMaterialTipo: datosImpresion.value.materialHeredado.codigoTipo,
    codigoFamiliaMaterial: datosImpresion.value.materialHeredado.codigoFamilia,
    filtroGenerico: filtroGenericoHeredado.value,
  };
});
// Cuando el usuario confirma una imposición desde el nuevo Modal
const handleAplicarImposicion = async ({ opcion, parametrosAjustados, maquinaGanadora }) => {
  const inmutable = { ...props.modelValue };

  if (maquinaGanadora?.Codigo && inmutable.Secciones) {
    const procesoObjetivo = obtenerProcesoValidaAncho(inmutable.Secciones);
    if (procesoObjetivo) {
      procesoObjetivo.Recurso = { ...maquinaGanadora };
    }
  }

  // 1. FACTOR DE CONVERSIÓN
  const factorConversor = unidad.value === 'in' ? FACTOR : 1;
  const desarrolloCalculado = opcion.cilindro * factorConversor;

  // 2. ACTUALIZAMOS MEDIDAS Y GAPS
  inmutable.MedidaEje = opcion.visualizacion.medidaAncho * factorConversor;
  inmutable.MedidaDesarrollo = opcion.visualizacion.medidaDesarrollo * factorConversor;
  inmutable.GapEje = opcion.visualizacion.gapAncho * factorConversor;
  inmutable.GapDesarrollo = opcion.visualizacion.gapDesarrollo * factorConversor;
  inmutable.Laterales = opcion.visualizacion.margenLateral * factorConversor;
  inmutable.CodigoMaterial = opcion.codigoMaterial;
  inmutable.Engranaje = opcion.engranaje;
  inmutable.Desarrollo = desarrolloCalculado;
  inmutable.AnchoMaterial = opcion.anchoRedondeado * factorConversor;
  inmutable.AnchoImpresion = opcion.anchoImpresion * factorConversor;

  inmutable.EtiquetasEje = opcion.bocasAncho;
  inmutable.EtiquetasDesarrollo = opcion.bocasDesarrollo;
  if (parametrosAjustados.formaTroquel) {
    const formaEncontrada = formaList.value.find(
      (f) => f.Codigo === parametrosAjustados.formaTroquel,
    );
    inmutable.Forma = formaEncontrada || { ...forma_model };
  }
  inmutable.RotacionImposicion = opcion.rotado ? 90 : 0;

  if (opcion.codigoTroquelSugerido) {
    inmutable.CodigoSuaje = opcion.codigoTroquelSugerido;
    inmutable.Suaje = {
      Codigo: opcion.codigoTroquelSugerido,
      CodigoSuaje: String(opcion.codigoTroquelSugerido),
    };
  } else {
    inmutable.CodigoSuaje = null;
    inmutable.Suaje = { ...suaje_model };
  }

  const matchDesarrollo = desarrollos.value.find(
    (d) => Math.abs(d.Desarrollo - desarrolloCalculado) < 0.1,
  );

  if (
    matchDesarrollo &&
    matchDesarrollo.CilindroTipoDesarrollo &&
    matchDesarrollo.CilindroTipoDesarrollo.length > 0
  ) {
    const c = matchDesarrollo.CilindroTipoDesarrollo[0];
    inmutable.CantidadCilindros = c.CantidadCilindros || 0;
    inmutable.CantidadMagneticos = c.CantidadMagneticos || 0;
    inmutable.CilindroNombre = c.CilindroTipo?.Descripcion || '';

    cantidadCilindros.value = c.CantidadCilindros || 0;
    cantidadMagneticos.value = c.CantidadMagneticos || 0;
    cilindros.value = c.CilindroTipo?.Descripcion || '';
  } else {
    inmutable.CantidadCilindros = null;
    inmutable.CantidadMagneticos = null;
    inmutable.CilindroNombre = null;

    cantidadCilindros.value = '-';
    cantidadMagneticos.value = '-';
    cilindros.value = '-';
  }

  // propagacion del material
  const procesoObjetivoMat = obtenerProcesoValidaAncho(inmutable.Secciones);

  if (procesoObjetivoMat && procesoObjetivoMat.CategoriasMaterial) {
    const catMatValidaAncho = procesoObjetivoMat.CategoriasMaterial.find(
      (catMat) =>
        catMat.ValidaAnchoMaterial === true ||
        catMat.CategoriaMaterial?.ValidaAnchoMaterial === true,
    );

    if (catMatValidaAncho) {
      if (!catMatValidaAncho.ElementoMateriales) {
        catMatValidaAncho.ElementoMateriales = [];
      }

      if (catMatValidaAncho.ElementoMateriales.length === 0) {
        catMatValidaAncho.ElementoMateriales.push({});
      }

      const targetRow = catMatValidaAncho.ElementoMateriales[0];

      let materialCompleto = null;
      try {
        const response = await MaterialService.findByCode(opcion.codigoMaterial);
        materialCompleto = response?.data || null;
      } catch (error) {
        materialCompleto = null;
      }

      targetRow.Material = materialCompleto || {
        Codigo: opcion.codigoMaterial,
        DescripcionInterna: opcion.descripcionMaterial,
      };
      targetRow.MaterialDesc = opcion.descripcionMaterial;
      targetRow.Espesor = materialCompleto?.Espesor ?? null;
      targetRow.Gramaje = materialCompleto?.Gramaje ?? null;
      targetRow.Ancho = opcion.anchoRedondeado * factorConversor;
    }
  }

  deshabilitarSeleccionImposicion.value = true;
  emits('update:modelValue', inmutable);
};

const anchoMinimoDisplay = computed(() => {
  const anchoMM = Number(anchoMinimoMM.value || 0);
  if (unidad.value === 'in') {
    const inches = anchoMM / FACTOR;
    return +inches.toFixed(4);
  }
  return +anchoMM.toFixed(2);
});

const precisionAnchoMinimo = computed(() => (unidad.value === 'in' ? 4 : 2));

/**
 * COTI-642: cuando el proceso que valida el ancho consume el material de un proceso
 * precedente (Extrusión) y no carga uno propio, `selectedMaterialAnchoMM` queda en 0. En ese
 * caso el ancho del item sale de la primera bobina de la Extrusión precedente, siguiendo los
 * procesos origen de los materiales o el proceso anterior por orden.
 */
const anchoHeredadoExtrusionMM = computed(() =>
  resolverAnchoItemDesdeExtrusionPrecedente(props.modelValue?.Secciones),
);

const anchoMaterialEfectivoMM = computed(() => {
  const propio = Number(selectedMaterialAnchoMM?.value || 0);
  return propio > 0 ? propio : Number(anchoHeredadoExtrusionMM.value || 0);
});

const anchoMaterialDisplay = computed(() => {
  const anchoMM = Number(anchoMaterialEfectivoMM.value || 0);
  const rounded = Math.round(anchoMM * 10000) / 10000;
  return unidad.value === 'in' ? +(rounded / FACTOR).toFixed(4) : rounded;
});

const cilindroNombreDisplay = computed(() =>
  props.modelValue.CilindroNombre ? String(props.modelValue.CilindroNombre).trim() : '-',
);

const cilindrosCantDisplay = computed(() =>
  props.modelValue.CantidadCilindros !== null &&
  props.modelValue.CantidadCilindros !== undefined &&
  props.modelValue.CantidadCilindros !== ''
    ? props.modelValue.CantidadCilindros
    : '-',
);

const magneticosCantDisplay = computed(() =>
  props.modelValue.CantidadMagneticos !== null &&
  props.modelValue.CantidadMagneticos !== undefined &&
  props.modelValue.CantidadMagneticos !== ''
    ? props.modelValue.CantidadMagneticos
    : '-',
);

const syncAnchoMaterialDisplay = () => {
  if (!aplicaRegla.value) return;
  const mm = Number(anchoMaterialEfectivoMM.value || 0);
  const val = unidad.value === 'in' ? +(mm / FACTOR).toFixed(4) : mm;
  if (Number(displayAnchoMaterial.value || 0) !== val) {
    displayAnchoMaterial.value = val;
  }
};
watch(() => selectedMaterialAnchoMM?.value, syncAnchoMaterialDisplay, { immediate: true });
watch(anchoHeredadoExtrusionMM, syncAnchoMaterialDisplay);
watch(unidad, syncAnchoMaterialDisplay);
watch(aplicaRegla, (v) => {
  if (v) syncAnchoMaterialDisplay();
});

const showAnchoWarning = computed(() => {
  if (!aplicaRegla.value) return false;
  if (!props.mostrarAnchoMinimo && !props.mostrarAnchoMaterial) return false;

  const min = Number(anchoMinimoMM.value || 0);
  const mat = Number(anchoMaterialEfectivoMM.value || 0);
  const EPSILON = 0.01;
  if (mat <= 0) return false;
  return min > 0 && min - mat > EPSILON;
});

watch(
  showAnchoWarning,
  (hasWarning) => {
    if (props.modelValue.ErrorAnchoMaterial !== hasWarning) {
      const inmutable = {
        ...props.modelValue,
        ErrorAnchoMaterial: hasWarning,
      };
      emits('update:modelValue', inmutable);
    }
  },
  { immediate: true },
);

/**
 * COTI-633: el pliego cargado (AnchoItem/LargoItem) no puede superar lo que admite la
 * máquina de impresión. Aviso adelantado del error duro que ya bloquea en el backend
 * (validarMaximoMaquinaPliego) — usa la misma máquina que ya resuelve datosImpresion
 * para el aviso de ancho de material, no una búsqueda nueva.
 */
const erroresMaximoMaquinaPliego = computed(() => {
  if (!props.mostrarAnchoLargoItem) return { ancho: null, largo: null };

  const maquina = datosImpresion.value.maquina;
  if (!maquina) return { ancho: null, largo: null };

  return calcularErrorMaximoMaquinaPliego({
    anchoPliego: toMillimeters(displayAnchoItem.value),
    largoPliego: toMillimeters(displayLargoItem.value),
    anchoMaximo: Number(maquina.AnchoMaximo ?? 0),
    largoMaximo: Number(maquina.LargoMaximo ?? 0),
  });
});

// Texto combinado, solo para el aviso inline bajo las medidas (las dos líneas si las dos
// dimensiones fallan a la vez) — el reporte al registro de errores va por separado, abajo.
const errorMaximoMaquinaPliego = computed(
  () =>
    [erroresMaximoMaquinaPliego.value.ancho, erroresMaximoMaquinaPliego.value.largo]
      .filter(Boolean)
      .join('\n') || null,
);

// COTI-633: se reporta al registro del *_edit.vue ancestro en vez de escribirse en el
// modelo — es estado de validación de UI, no un dato del elemento que haya que guardar. Ancho
// y largo van con su propia clave: son fallas independientes y deben listarse como mensajes
// separados en la notificación, no combinados en uno solo.
const reportarErrorMaximoMaquinaPliegoAncho = useErrorRegistro('maximoMaquinaPliegoElementoAncho');
watch(
  () => erroresMaximoMaquinaPliego.value.ancho,
  (mensaje) => {
    reportarErrorMaximoMaquinaPliegoAncho(!!mensaje, mensaje ?? '');
  },
  { immediate: true },
);

const reportarErrorMaximoMaquinaPliegoLargo = useErrorRegistro('maximoMaquinaPliegoElementoLargo');
watch(
  () => erroresMaximoMaquinaPliego.value.largo,
  (mensaje) => {
    reportarErrorMaximoMaquinaPliegoLargo(!!mensaje, mensaje ?? '');
  },
  { immediate: true },
);

/**
 * COTI-633: el pliego cargado tampoco puede quedar por debajo del mínimo que necesita la
 * imposición (mismo criterio que el aviso visual de medida_pliego.vue, vía
 * noLlegaAlMinimoPliego) — antes era sólo un aviso, ahora también bloquea el guardado igual
 * que el máximo de máquina.
 */
const errorMinimoPliegoAncho = computed(() => {
  if (!props.mostrarAnchoLargoItem) return null;
  const noLlega = noLlegaAlMinimoPliego({
    medida: displayAnchoItem.value,
    minimo: minimoEnUnidad(props.modelValue.AnchoMinimoHojaCalculado),
  });
  return noLlega ? 'El ancho del pliego no llega al mínimo' : null;
});

const errorMinimoPliegoLargo = computed(() => {
  if (!props.mostrarAnchoLargoItem) return null;
  const noLlega = noLlegaAlMinimoPliego({
    medida: displayLargoItem.value,
    minimo: minimoEnUnidad(props.modelValue.LargoMinimoHojaCalculado),
  });
  return noLlega ? 'El largo del pliego no llega al mínimo' : null;
});

const reportarErrorMinimoPliegoAncho = useErrorRegistro('minimoPliegoAnchoElemento');
watch(
  errorMinimoPliegoAncho,
  (mensaje) => {
    reportarErrorMinimoPliegoAncho(!!mensaje, mensaje ?? '');
  },
  { immediate: true },
);

const reportarErrorMinimoPliegoLargo = useErrorRegistro('minimoPliegoLargoElemento');
watch(
  errorMinimoPliegoLargo,
  (mensaje) => {
    reportarErrorMinimoPliegoLargo(!!mensaje, mensaje ?? '');
  },
  { immediate: true },
);

const forma = computed({
  set(valor) {
    handlePropiedadElemento(valor, 'Forma');
  },
  get() {
    return props.modelValue.Forma;
  },
});

const deshabilitarCamposSuaje = computed(() =>
  props.modelValue.Suaje && props.modelValue.Suaje.Codigo > 0
    ? true
    : deshabilitarSeleccionImposicion.value,
);

const handleAbrirBuscarSuaje = () => (buscarSuajeVisible.value = true);

const handleCerrarBuscarSuaje = () => (buscarSuajeVisible.value = false);

const handleAbrirBuscarEngranaje = () => {
  // const pluginsSoportados = ['ETIQUETA_FLEXO'];

  // if (!pluginsSoportados.includes(elementoTipoBackend.value)) {
  //   ElNotification({
  //     title: 'Próximamente',
  //     message: `El cálculo automático de imposición para "${props.modelValue.ElementoTipo?.Descripcion}" aún no está disponible.`,
  //     type: 'warning'
  //   });
  //   return;
  // }
  if (nuevoMotorImposicion.value) {
    if (!props.modelValue.MedidaDesarrollo || !props.modelValue.MedidaEje) {
      ElNotification({
        title: 'Error',
        message: 'Faltan medidas para calcular la imposición.',
        type: 'error',
      });
      return;
    }

    buscarImposicionVisible.value = true;
  } else {
    if (props.modelValue.MedidaDesarrollo) {
      buscarEngranjeVisible.value = true;
    } else {
      ElNotification({
        title: 'Error',
        message: 'Para la búsqueda se necesita Medida Desarrollo',
        type: 'error',
      });
    }
  }
};

const deseleccionarImposicion = () => {
  cantidadCilindros.value = '';
  cantidadMagneticos.value = '';
  cilindros.value = '';
  deshabilitarSeleccionImposicion.value = false;

  const inmutable = {
    ...props.modelValue,
    Engranaje: 0,
    Desarrollo: 0,
    GapDesarrollo: 0,
    EtiquetasDesarrollo: 0,
    CilindroNombre: null,
    CantidadCilindros: null,
    CantidadMagneticos: null,
  };
  emits('update:modelValue', inmutable);
};

const seleccionarSuaje = (suaje) => {
  if (suaje) {
    const inmutable = { ...props.modelValue };

    inmutable.MedidaDesarrollo = suaje.MedidaDesarrolloMm || 0;
    inmutable.MedidaEje = suaje.MedidaEjeMm || 0;
    inmutable.GapEje = suaje.GapEjeMm || 0;

    if (suaje.EtiquetasEje !== undefined && suaje.EtiquetasEje !== null) {
      inmutable.EtiquetasEje = suaje.EtiquetasEje;
    }

    // 🆕 COTI-480: si el suaje es plano, la cantidad de bocas de impresión se calcula
    // según la relación del adaptador (ver useSuajeAdaptador.js)
    const esPlano = suaje.SuajeTipo?.ClaveInterna === 'plano';
    inmutable.EtiquetasDesarrollo = esPlano
      ? calcularEtiquetasDesarrolloImpresion(suaje)
      : suaje.EtiquetasDesarrollo || 0;

    inmutable.Desarrollo = esPlano
      ? (suaje.Adaptador.Desarrollo?.Desarrollo ?? 0)
      : (suaje.Desarrollo ?? 0);

    inmutable.Forma = suaje.Forma || { ...forma_model };
    inmutable.Engranaje = esPlano
      ? suaje.Adaptador?.Desarrollo?.Engranaje || 0
      : suaje.Engranaje || 0;
    inmutable.CilindroNombre = suaje.Recurso || null;
    inmutable.CantidadCilindros = esPlano
      ? suaje.Adaptador.CantidadCilindros
      : suaje.CantidadCilindros || null;
    inmutable.CantidadMagneticos = esPlano
      ? suaje.Adaptador.CantidadMagneticos
      : suaje.CantidadMagneticos || null;
    if (suaje.Laterales !== undefined && suaje.Laterales !== null) {
      inmutable.Laterales = suaje.Laterales;
    }
    inmutable.Suaje = { ...suaje };
    inmutable.CodigoSuaje = suaje.Codigo;

    // Asignar adaptador si existe
    inmutable.Adaptador = suaje.Adaptador ? { ...suaje.Adaptador } : null;
    inmutable.CodigoAdaptador = suaje.Adaptador?.Codigo ?? null;

    // COTI-480: si el suaje es plano, el gap al desarrollo se calcula con el desarrollo del adaptador
    inmutable.GapDesarrollo = esPlano
      ? calcularGapDesarrollo(
          suaje.Adaptador?.Desarrollo?.Desarrollo ?? 0,
          inmutable.EtiquetasDesarrollo,
          inmutable.MedidaDesarrollo,
        )
      : suaje.GapDesarrolloMm || 0;

    if (
      suaje.SuajeMateriaPrimaFamilia &&
      suaje.SuajeMateriaPrimaFamilia[0] &&
      suaje.SuajeMateriaPrimaFamilia[0].MateriaPrimaFamilia &&
      suaje.SuajeMateriaPrimaFamilia[0].MateriaPrimaFamilia.Codigo
    ) {
      inmutable.MateriaPrimaFamilia = suaje.SuajeMateriaPrimaFamilia[0].MateriaPrimaFamilia;
      setTimeout(() => {
        window.dispatchEvent(new CustomEvent('materia-prima-familia', {}));
      }, 300);
    }

    emits('update:modelValue', inmutable);
  }
};

const deseleccionarSuaje = () => {
  const inmutable = {
    ...props.modelValue,
    GapEje: 0,
    GapDesarrollo: 0,
    EtiquetasEje: 0,
    EtiquetasDesarrollo: 0,
    Forma: { ...forma_model },
    Engranaje: 0,
    Desarrollo: 0,
    Laterales: 0,
    Suaje: { ...suaje_model },
    CodigoAdaptador: null,
    Adaptador: null,
  };

  emits('update:modelValue', inmutable);
};

const handlePropiedadElemento = (valor, propiedad) => {
  const inmutable = {
    ...props.modelValue,
    [propiedad]: valor,
  };

  emits('update:modelValue', inmutable);
};

const numericEtiquetasEje = computed(() => {
  const v = props.modelValue.EtiquetasEje;
  return v != null && !isNaN(v) ? Math.max(0, Math.floor(v)) : 0;
});
const numericEtiquetasDesarrollo = computed(() => {
  const v = props.modelValue.EtiquetasDesarrollo;
  return v != null && !isNaN(v) ? Math.max(0, Math.floor(v)) : 0;
});
const numericGapEje = computed(() => {
  return toMillimeters(displayGapEje.value);
});
const numericGapDesarrollo = computed(() => {
  return toMillimeters(displayGapDesarrollo.value);
});
const numericMedidaEje = computed(() => {
  return toMillimeters(displayMedidaEje.value);
});
const numericMedidaDesarrollo = computed(() => {
  return toMillimeters(displayMedidaDesarrollo.value);
});
const numericLaterales = computed(() => {
  return toMillimeters(displayLaterales.value);
});
const numericAnchoTotal = computed(() => {
  const ancho = displayMedidaEje.value;
  const base = displayBase.value;
  const sellado = displaySellado.value;
  let anchoTotal = 0;
  if (ElementoBase.BOLSAS_FUELLE === props.modelValue.ElementoTipo.CodigoElementoBase) {
    anchoTotal = ancho;
  }
  if (ElementoBase.BOLSAS_BOX === props.modelValue.ElementoTipo.CodigoElementoBase) {
    anchoTotal = ancho + base + sellado;
  }
  return toMillimeters(anchoTotal);
});
const numericAltoTotal = computed(() => {
  const alto = displayMedidaDesarrollo.value;
  const solapa = displaySolapa.value;
  const base = displayBase.value;
  return toMillimeters(alto * 2 + solapa * 2 + base);
});

const rotarImposicion = (sentido) => {
  let index = rotaciones.indexOf(rotacionImposicion.value);
  if (sentido === 'left') {
    index = index - 1;
    if (index < 0) index = 3;
  } else {
    index = index + 1;
    if (index > rotaciones.length - 1) index = 0;
  }

  emits('update:modelValue', { ...props.modelValue, RotacionImposicion: rotaciones[index] });
};

const rotacionImposicion = computed(() => {
  return props.modelValue.RotacionImposicion;
});

const cavidadesAncho = computed(() => {
  if ([ROTACION_0, ROTACION_180].includes(rotacionImposicion.value)) {
    return numericEtiquetasEje.value;
  }
  return numericEtiquetasDesarrollo.value;
});

const cavidadesDesarrollo = computed(() => {
  if ([ROTACION_0, ROTACION_180].includes(rotacionImposicion.value)) {
    return numericEtiquetasDesarrollo.value;
  }
  return numericEtiquetasEje.value;
});

const gapEje = computed(() => {
  if ([ROTACION_0, ROTACION_180].includes(rotacionImposicion.value)) {
    return numericGapEje.value;
  }
  return numericGapDesarrollo.value;
});

const gapDesarrollo = computed(() => {
  if ([ROTACION_0, ROTACION_180].includes(rotacionImposicion.value)) {
    return numericGapDesarrollo.value;
  }
  return numericGapEje.value;
});

const medidaEje = computed(() => {
  if ([ROTACION_0, ROTACION_180].includes(rotacionImposicion.value)) {
    return numericMedidaEje.value;
  }
  return numericMedidaDesarrollo.value;
});

const medidaDesarrollo = computed(() => {
  if ([ROTACION_0, ROTACION_180].includes(rotacionImposicion.value)) {
    return numericMedidaDesarrollo.value;
  }
  return numericMedidaEje.value;
});

const rotacionAnchoImposicion = computed(() => {
  if ([ROTACION_0, ROTACION_180].includes(rotacionImposicion.value)) {
    return props.anchoImposicion;
  }
  return props.largoImposicion;
});

const rotacionLargoImposicion = computed(() => {
  if ([ROTACION_0, ROTACION_180].includes(rotacionImposicion.value)) {
    return props.largoImposicion;
  }
  return props.anchoImposicion;
});

const aspectRatio = computed(() => {
  if ([ROTACION_0, ROTACION_180].includes(rotacionImposicion.value)) {
    if (numericMedidaEje.value === 0) return 1;
    return numericMedidaDesarrollo.value / numericMedidaEje.value;
  }
  if (numericMedidaDesarrollo.value === 0) return 1;
  return numericMedidaEje.value / numericMedidaDesarrollo.value;
});

const maxDisplayWidth = computed(() => {
  if ([ROTACION_0, ROTACION_180].includes(rotacionImposicion.value)) {
    return MAX_DISPLAY_WIDTH;
  }
  return MAX_DISPLAY_HEIGHT;
});

const maxDisplayHeight = computed(() => {
  if ([ROTACION_0, ROTACION_180].includes(rotacionImposicion.value)) {
    return MAX_DISPLAY_HEIGHT;
  }
  return MAX_DISPLAY_WIDTH;
});

onMounted(() => {
  swageUsed.value = false;
});

onBeforeMount(() => {
  // mostrarBotonesRotacion.value =  configuracionList.value.find(c => c.Codigo === 22)?.Valor.toLowerCase() == 'true' ? true : false
  tolMin.value = +(gapToleranciaMinima.value ?? 0);
  tolMax.value = +(gapToleranciaMaxima.value ?? 1);
  firstForma();
  (async () => {
    await desarrollosStore.findAllDesarrollos({ page: 0 });
  })();

  if (!rotaciones.includes(props.modelValue.RotacionImposicion)) {
    emits('update:modelValue', {
      ...props.modelValue,
      RotacionImposicion: +(rotacionImposicionDefault.value ?? 0),
    });
  }

  aplicarValoresPorDefectoImposicion();
});

// Completa Laterales/Gap eje/Gap desarrollo con los valores configurados en el ABM de
// Configuraciones por defecto. Solo aplica a un elemento recién creado (sin persistir y sin
// suaje elegido todavía), para no pisar operaciones ya generadas ni valores duplicados.
function aplicarValoresPorDefectoImposicion() {
  const esElementoNuevo = !props.modelValue.Codigo && !props.modelValue.CodigoSuaje;
  if (!esElementoNuevo) return;

  const cambios = {};
  if (!props.modelValue.Laterales && lateralesImposicion.value !== null) {
    cambios.Laterales = lateralesImposicion.value;
  }
  if (!props.modelValue.GapEje && gapEjeImposicion.value !== null) {
    cambios.GapEje = gapEjeImposicion.value;
  }
  if (!props.modelValue.GapDesarrollo && gapDesarrolloImposicion.value !== null) {
    cambios.GapDesarrollo = gapDesarrolloImposicion.value;
  }

  if (Object.keys(cambios).length > 0) {
    emits('update:modelValue', { ...props.modelValue, ...cambios });
  }
}

watch(unidad, (nuevoValor) => {
  const inmutable = {
    ...props.modelValue,
    UnidadMedida: nuevoValor,
  };
  emits('update:modelValue', inmutable);
  emits('update:unidadImposicion', nuevoValor);
});
watch(
  () => props.modelValue.UnidadMedida,
  (nuevo) => {
    if (!nuevo) return;
    const normalizado = nuevo.toLowerCase();
    if (normalizado !== unidad.value) {
      unidad.value = normalizado;
    }
  },
);
</script>

<style scoped>
.custom-label {
  font-weight: 700;
  color: #111;
}

/* Aplica el margen a la izquierda para alinear a la derecha */
.custom-confirm-buttons {
  margin-left: auto;
}

.custom-title {
  color: #66b1ff;
}

.button-container {
  width: 100%;
  transform: translateY(40%);
}

.button-container-upload {
  margin-top: 25%;
}

.full-width-button {
  width: 35%;
}

.file-upload {
  display: none;
}

.file-list {
  margin-top: 10px;
  list-style-type: none;
}

.file-list li {
  display: flex;
  align-items: center;
  margin-bottom: 5px;
}

.file-list li i {
  margin-left: 5px;
  cursor: pointer;
}

.upload-list {
  width: 100%;
}
.helper-danger {
  color: #e42727;
  font-size: 12px;
  white-space: pre-line;
}
</style>
